import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { projects, projectCategories } from '../mockData';
import { ArrowUpRight } from 'lucide-react';
import { PageLayout } from '../components/PageLayout';


export const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredProjects = selectedCategory === 'all'
    ? projects
    : projects.filter(project => project.category === selectedCategory);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-active');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [filteredProjects]);

  return (
    <PageLayout className="bg-[#f5f7fa]">
      {/* Hero Section */}
      <section className="relative -mt-20 lg:pt-40 pt-28 pb-0 bg-[#262d37] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <h1 className="text-2xl md:text-3xl font-bold mb-1">
              Os Nossos Projetos
            </h1>
            <p className="text-base md:text-lg text-neutral-300">
              Explore o nosso portfólio de projetos de iluminação em hospitais, escolas, universidades e centros culturais por todo o país.
            </p>

          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-2 lg:mt-6">
          <div className="flex flex-nowrap md:flex-wrap items-center justify-start gap-3 overflow-x-auto md:overflow-visible px-1 sm:px-0 py-4 scrollbar-hide">
            {projectCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`
                  whitespace-nowrap px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-500
                  ${selectedCategory === category.id
                    ? 'bg-white text-black shadow-xl scale-105'
                    : 'text-neutral-400 hover:text-white hover:bg-white/10 border border-white/20'
                  }
                `}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-10 lg:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <Link
                key={project.id}
                to={`/projetos/${project.id}`}
                className="group block reveal"
              >
                <div className="relative h-[450px] overflow-hidden rounded-3xl shadow-xl project-card-transition project-card-hover">
                  <img
                    src={project.image}
                    alt={project.title}
                    loading="lazy"
                    onLoad={(e) => e.target.classList.add('img-loaded')}
                    className="w-full h-full object-cover group-hover:scale-110 project-card-image-zoom img-smooth"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />
                  <div className="absolute inset-0 p-8 flex flex-col justify-end text-white">
                    <div className="flex gap-2 mb-4">
                      <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-[10px] uppercase tracking-wider font-bold">
                        {project.year}
                      </span>
                      <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-[10px] uppercase tracking-wider font-bold">
                        {projectCategories.find(cat => cat.id === project.category)?.name}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold mb-3 group-hover:translate-x-1 transition-transform duration-300">
                      {project.title}
                    </h3>
                    <div className="flex items-center gap-2 text-white font-semibold group-hover:text-neutral-200 transition-colors">
                      <span className="text-sm">Ver Detalhes</span>
                      <ArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" size={14} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-16">
              <p className="text-base text-neutral-500">
                Nenhum projeto encontrado nesta categoria.
              </p>
            </div>
          )}
        </div>
      </section>
    </PageLayout>
  );
};
